import { RootState } from "@redux/store";
import { UserRole } from "@tsTypes/users";
import { setPrevUrlCookie } from "@utils/authUtils";
import devConsole from "@utils/devConsole";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";

const PrivateSponsorRoute = ({ ...props }) => {
  const currentUser = useSelector((state: RootState) => state.profiles.currentUser);

  if (!currentUser.id) {
    setPrevUrlCookie(window.location.href);
    window.location.href = "/login";
  }

  if (currentUser.role !== UserRole.SPONSOR) {
    devConsole.warn("User %o attempted to access sponsor-only route.", currentUser);
    return <Redirect to="/403" />;
  }

  return <PrivateRoute {...props} />;
};

export default PrivateSponsorRoute;
